import { styled } from '@mui/material';
import { DesignTokens } from '../specify';

export const CheckListContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',

    '& .divider-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    '& .divider': {
        width: '24px',

        [theme.breakpoints.down('mobile')]: {
            width: '40px',
        },
    },

    [theme.breakpoints.down('mobile')]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        maxWidth: '286px',
        margin: 'auto',
        gap: 0,
    },
}));

export const ChecklistTabItem = styled('div', {
    shouldForwardProp: (prop) =>
        prop !== 'highlight' && prop !== 'mobilemaxlabelwidth',
})<{ highlight?: boolean; mobilemaxlabelwidth?: number }>(
    ({ theme, highlight, mobilemaxlabelwidth }) => ({
        background: 'transparent',
        padding: '0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        color: highlight
            ? DesignTokens.color.textPrimary
            : DesignTokens.color.textSecondary,
        fontWeight: highlight ? 800 : 600,
        cursor: 'pointer',

        [theme.breakpoints.down('mobile')]: {
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'start',
            fontWeight: 700,
            fontSize: '12px',
            color: highlight
                ? DesignTokens.color.textPrimary
                : DesignTokens.color.textSecondary,

            '& .tab-label': {
                lineHeight: '18px',
                width: mobilemaxlabelwidth
                    ? mobilemaxlabelwidth + 'px'
                    : 'auto',
            },
        },
    }),
);

export const TabBadge = styled('div', {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
})<{ active?: boolean; completed?: boolean }>(
    ({ theme, active, completed }) => ({
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: active
            ? DesignTokens.color.borderComponentPrimaryAccent
            : completed
            ? DesignTokens.color.borderComponentSuccess
            : DesignTokens.color.backgroundDefault,
        border:
            active || completed
                ? 'none'
                : `1px solid ${DesignTokens.color.dividerPrimaryLight}`,
        color: active
            ? DesignTokens.color.textWhite
            : completed
            ? DesignTokens.color.textWhite
            : DesignTokens.color.textSecondary,
        marginRight: '8px',

        '& .icon': {
            fontSize: '16px',
        },

        [theme.breakpoints.down('mobile')]: {
            marginRight: '0',
            marginBottom: '8px',
        },
    }),
);
